import ItcCollapse from "../assets/collapse.js";

//! ---------------------------------- Корневые элементы ------------------------------------
const $ = {
    header: document.querySelector('.page__header'),
    bttnSearch: document.querySelector('.header__button-sidebarcatalog'),
    burgerButton: document.querySelector('.burger-button'),
    sidebarCatalog: document.querySelector('.page__sidebar-catalog'),
    sidebarMenu: document.querySelector('.page__sidebar-menu'),
    bottomMenu: document.querySelector('.page__buttom-menu'),
    cancelButtonsCatalog: document.querySelector('.catalog-cansel'),
    cancelButtonsMenu: document.querySelector('.menu-cansel'),
    menuParents: document.querySelectorAll('.menu-catalog__parent-menu'),
    menuCatalog: document.querySelector('.menu-catalog'),
    catalogCategories: document.querySelector('.catalog__categories'),
    submenuParents: document.querySelectorAll('.submenu-parent'),
    userButtons: document.querySelectorAll('.login-container__user-button'),
    favouritItems: document.querySelectorAll('.slide-container__favourit')
};

//! -------------------------- Вспомогательные функции -------------------------------
/**
 * Проверка существования DOM-элемента
 */
function exists(el, name = 'element') {
    if (!el) {
        console.warn(`[UI] ${name} не найден`);
        return false;
    }
    return true;
}

/**
 * Переключение состояния меню с поддержкой collapse
 */
function _toggleMenu(el, collapse) {
    if (!el) return;

    if (el.classList.contains('_active') || el.classList.contains('_open')) {
        el.classList.remove('_active', '_open');
        if (collapse) collapse.toggle();
    } else {
        el.classList.add('_active', '_open');
        if (collapse) collapse.toggle();
    }
}

/**
 * Поиск элемента внутри login-container
 */
function loginList(target, selector) {
    const container = target.closest('.login-container');
    if (!container) return null;
    return container.querySelector(selector);
}

/**
 * Безопасное удаление класса
 */
function removeElement(el, className) {
    if (!el) return;
    el.classList.remove(className);
}

/**
 * Закрытие модального окна
 */
function closeModal(el, modal) {
    if (!el || !modal) return;
    el.addEventListener('click', () => modal.classList.remove('_show'));
}

//! -------------------------- Основные UI функции -------------------------------
function openMenuCatalog() {
    if (
        !exists($.bttnSearch, 'Кнопка каталога') ||
        !exists($.sidebarCatalog, 'Сайдбар каталога') ||
        !exists($.sidebarMenu, 'Сайдбар меню') ||
        !exists($.burgerButton, 'Бургер кнопка')
    ) return;

    $.bttnSearch.addEventListener('click', () => {
        $.sidebarCatalog.classList.toggle('_opened-menu');
        $.sidebarMenu.classList.remove('_opened-menu');
        $.bttnSearch.classList.toggle('_active');
        $.burgerButton.classList.remove('_active');

        document.body.classList.toggle(
            'no-scroll',
            $.sidebarCatalog.classList.contains('_opened-menu')
        );
    });
}

function addFafouritItems() {
    if (!$.favouritItems || !$.favouritItems.length) {
        console.warn('[UI] Элементы избранного не найдены');
        return;
    }

    $.favouritItems.forEach(item => {
        item.addEventListener('click', () => {
            item.classList.toggle('_add-product');
        });
    });
}

function openMainMenu() {
    if (
        !exists($.burgerButton, 'Бургер кнопка') ||
        !exists($.sidebarMenu, 'Сайдбар меню') ||
        !exists($.sidebarCatalog, 'Сайдбар каталога')
    ) return;

    $.burgerButton.addEventListener('click', () => {
        $.sidebarMenu.classList.toggle('_opened-menu');
        $.sidebarCatalog.classList.remove('_opened-menu');
        $.burgerButton.classList.toggle('_active');
        $.bttnSearch?.classList.remove('_active');

        document.body.classList.toggle(
            'no-scroll',
            $.sidebarMenu.classList.contains('_opened-menu')
        );
    });
}

function showSubMenuCollapse() {
    if (!$.submenuParents || !$.submenuParents.length) return;

    $.submenuParents.forEach(parent => {
        const trigger = parent.querySelector('.submenu-parent__link');
        if (!trigger) return;

        trigger.addEventListener('click', () => {
            if (trigger.classList.contains('_trigger')) {
                _toggleMenu(parent);
            }
        });
    });
}

function collapseElement() {
    const menuParents = document.querySelectorAll('.menu-catalog__parent-menu');
    const menuList = document.querySelector('.sidebar-catalog__menu');

    if (!menuParents.length || !menuList) return;

    menuParents.forEach(menuParent => {
        const trigger = menuParent.querySelector('._trigger-menu');
        const collapseEl = menuParent.querySelector('._collapse');

        if (!trigger || !collapseEl) return;

        const collapse = new ItcCollapse(collapseEl);

        trigger.addEventListener('click', () => {
            const openedMenu = menuList.querySelector('._open');

            _toggleMenu(menuParent, collapse);

            if (openedMenu && openedMenu !== menuParent) {
                const openedCollapseEl = openedMenu.querySelector('._collapse');
                if (openedCollapseEl) {
                    _toggleMenu(openedMenu, new ItcCollapse(openedCollapseEl));
                }
            }
        });
    });
}

function collapseCatalogFilter() {
    if (!exists($.catalogCategories, 'Категории каталога')) return;

    const trigger = $.catalogCategories.querySelector('._trigger');
    const collapseEl = $.catalogCategories.querySelector('._collapse');

    if (!trigger || !collapseEl) return;

    const collapse = new ItcCollapse(collapseEl);

    trigger.addEventListener('click', () => {
        _toggleMenu($.catalogCategories, collapse);
    });
}

function loadedCatalog() {
    document.addEventListener('DOMContentLoaded', () => {
        if (!$.menuCatalog) return;

        const activeMenu = $.menuCatalog.querySelector('._active');
        if (!activeMenu) return;

        const collapseEl = activeMenu.querySelector('._collapse');
        if (!collapseEl) return;

        _toggleMenu(activeMenu, new ItcCollapse(collapseEl));
    });
}

function placeOrder() {
    const orderCollapse = document.querySelector('.send-order');
    const formButton = document.querySelector('.order-place__form-button');

    if (!orderCollapse || !formButton) return;

    const collapseEl = orderCollapse.querySelector('._collapse');
    if (!collapseEl) return;

    const collapse = new ItcCollapse(collapseEl);
    const checkbox = document.querySelector('.order-place__checkbox');

    formButton.addEventListener('click', () => {
        document.querySelector('.cart-page__title').textContent = 'оформление заказа';
        document.querySelector('.order-place__send-button').style.setProperty('display', 'block');
        formButton.style.display = 'none';
        checkbox?.style.setProperty('display', 'block');
        collapse.toggle();
    });
}

function userMenu() {
    if (!$.userButtons || !$.userButtons.length) return;

    $.userButtons.forEach(btn => {
        btn.addEventListener('click', e => {
            const target = e.target;
            const content = loginList(target, '.login-container__list');
            content?.classList.toggle('_visible');

            removeElement(loginList(target, '.login-modal'), '_show');
            removeElement(loginList(target, '.registrations-modal'), '_show');
            removeElement(loginList(target, '.recovery-modal'), '_show');
        });
    });
}

//! -------------------------- Инициализация ---------------------------
export function initAllUIFunctions() {
    openMenuCatalog();
    openMainMenu();
    showSubMenuCollapse();
    collapseElement();
    collapseCatalogFilter();
    loadedCatalog();
    placeOrder();
    userMenu();

    console.log('[UI] Все функции успешно инициализированы');
}

export {
    openMenuCatalog,
    openMainMenu,
    showSubMenuCollapse,
    collapseElement,
    collapseCatalogFilter,
    loadedCatalog,
    placeOrder,
    userMenu
};
